export default __webpack_public_path__ + "static/media/Duryodhan.6854484f.png";